<style type="text/css">


.shipment-count_text{
	color: #2D9CDB;
}
.custome-tab .v-tab::before,
.pickup-agent-chips:hover{
	background-color: transparent !important; 
}


</style>
<!-- status-text-filter -->
<template>
	<div>
		<v-card class="elevation-0">
			<v-tabs
			background-color="transparent"
			hide-slider
			show-arrows
			class="custome-tab"
			>
			<v-tab
			class="filter-btn pickup-agent-chips status-text-filter px-4 py-1 ma-2 cursor-pointer border-rounded"
			:class="pickup_agent=='All'?'elevation-1':''" 
			@click="selectPickupAgent('All')"
			:ripple="false"
			>
			<span style="line-height:24px">
				All
			</span>
		</v-tab>
		
		<v-tab
		class="filter-btn status-text-filter px-4 py-1 ma-2 cursor-pointer border-rounded"
		v-for="(agent,i) in pickup_agent_list"
		:class="pickup_agent.id==agent.id?'elevation-1':''" 
		@click="selectPickupAgent(agent)"
		:key="i"
		:ripple="false"
		>
		{{agent.agent_name}}
		<span>
			-
		</span>
		<span class="fs-16 fw-bold shipment-count_text">
			{{agent.shipment_count}}
		</span>
	</v-tab>
</v-tabs>
</v-card>

</div>
</template>
<script type="text/javascript">
export default{
	data(){
		return{
			tab:null,
			pickup_agent_list:[],
			pickup_agent:"All",
		}
	},
	created(){
		this.getPickupAgents2()
		this.getPickupAgents()

	},
	beforeRouteLeave (to, from, next) {
		const self=this
		let url = this.$urls.BASE_URL+this.$urls.AGENT_LIST+"?page_number="+this.page_number+"&page_length="+30+"&filter_agent_type="+JSON.stringify([self.$keys.PICKUP_AGENT])+"&order_by=shipment_count"+"&is_active="+true
		this.$polling.removeObserver(url)
		next()
	},
	methods:{
		/* get pickup agent data in throught polling  */ 
		getPickupAgents(){
			const self=this
			let url = this.$urls.BASE_URL+this.$urls.AGENT_LIST+"?page_number="+this.page_number+"&page_length="+30+"&filter_agent_type="+JSON.stringify([self.$keys.PICKUP_AGENT])+"&order_by=shipment_count"+"&is_active="+true;
			let warehouse_id=""

			if(self.$store.state.warehouse)
				warehouse_id=self.$store.state.warehouse.id

			this.$polling.addObserver(url, {
				interval: this.$store.state.polling_interval, 
				maxFails: 10,   
				headers: {
					"token":sessionStorage.getItem("token"),
					'warehouse-id':warehouse_id,
					"application-type":"web",
				}
			});
			this.$options.listeners[url] = (response) => {
				if (response.data.success){
					if(self.pickup_agent_list!=response.data.agent_list) {
						self.selectPickupAgent(self.pickup_agent)
						self.pickup_agent_list=response.data.agent_list
					}
				}
			}
		},

		/* get pickup agnt list for  the fist load and update the data */
		getPickupAgents2(){
			const self=this
			self.$store.dispatch('setPageLoader', true)
			self.filter_agent_type=status
			let params={
				order_by:"shipment_count",
				is_active:true,
				page_number:this.page_number,
				page_length:30,
				search_query:this.search_query,
				filter_agent_type:JSON.stringify([self.$keys.PICKUP_AGENT])
			};

			const successHandler = (response) => {
				if(response.data.success){
					self.pickup_agent_list=response.data.agent_list
					self.selectPickupAgent(self.pickup_agent)
				}
			};
			const finallyHandler = () => {
				self.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.AGENT_LIST,params,successHandler,null,null,finallyHandler)
		},

		
		selectPickupAgent(pickup_agent){
			this.pickup_agent=pickup_agent
			this.$emit("update-pickup-agent", pickup_agent);
		}
	}
}
</script>